module.exports = __webpack_public_path__ + "fonts/ZingScriptRustR-Base.c8085bf1.woff";